import type dayjs from 'dayjs'
import { computed, defineComponent, Teleport } from 'vue'

import BaseModal from '@/components/base/modal/BaseModal'
import DatePicker from '@/components/common/date/DatePicker'
import VIcon from '@/components/common/VIcon'
import useMenuModal from '@/composables/common/modal/useMenuModal'

interface Props {
  tData?: string
  modalkey: symbol
  class?: string
  title?: string
  value?: dayjs.Dayjs | null
  min?: dayjs.Dayjs | null
  max?: dayjs.Dayjs | null
  onChange?: (selectedDate: dayjs.Dayjs) => void
}

export default defineComponent<Props>((props) => {
  const mainModal = useMenuModal(props.modalkey)

  // #region Props Getters

  const tData = computed((): string => props.tData ?? 'select-date-modal')

  return () => (
    <Teleport to='body'>
      <BaseModal
        t-data={tData.value}
        modalkey={mainModal.key}
      >
        <div class={['flex w-screen flex-col bg-white pb-6', props.class]}>
          <div class='flex h-12 w-full items-center justify-center border-b border-neutral-300 px-4 py-3'>
            <h1 class='flex-1 text-subtitle-1'>{props.title}</h1>
            <button
              t-data='menu-modal-close-btn'
              onClick={() => { mainModal.cancel() }}
            >
              <VIcon
                class='text-[24px]'
                icon='material-symbols:close'
              />
            </button>
          </div>
          <div class='flex justify-center'>
            <DatePicker
              class='max-w-[375px] !shadow-none'
              value={props.value}
              min={props.min}
              max={props.max}
              fullWidth
              color='white'
              onChange={(newValue) => {
                props.onChange?.(newValue)
              }}
            />
          </div>
        </div>
      </BaseModal>
    </Teleport>
  )
}, {
  name: 'SelectDateModal',
  props: [
    'tData',
    'modalkey',
    'class',
    'title',
    'value',
    'min',
    'max',
    'onChange'
  ]
})
